import { useState } from 'react';
import { CurrencyRupeeIcon, WalletIcon, CreditCardIcon } from '@heroicons/react/24/outline';

const EnrollmentModal = ({ course, user, onEnroll, onClose, enrollmentLoading }) => {
  const [useWallet, setUseWallet] = useState(false);

  const walletBalance = user?.walletBalance || 0;
  const courseFees = course?.fees || 0;
  const walletAmountUsed = useWallet && walletBalance > 0 ? Math.min(walletBalance, courseFees) : 0;
  const finalAmount = courseFees - walletAmountUsed;

  const handleEnroll = () => {
    onEnroll(useWallet);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Enroll in {course?.title}
          </h3>

          <div className="space-y-4">
            {/* Course Fee */}
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Course Fee:</span>
              <span className="font-semibold flex items-center">
                <CurrencyRupeeIcon className="h-4 w-4 mr-1" />
                {courseFees}
              </span>
            </div>

            {/* Wallet Balance */}
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Wallet Balance:</span>
              <span className="font-semibold flex items-center">
                <WalletIcon className="h-4 w-4 mr-1" />
                {walletBalance}
              </span>
            </div>

            {/* Wallet Usage Option */}
            {walletBalance > 0 && (
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="useWallet"
                  checked={useWallet}
                  onChange={(e) => setUseWallet(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="useWallet" className="text-sm text-gray-700 cursor-pointer">
                  Use ₹{Math.min(walletBalance, courseFees)} from wallet
                </label>
              </div>
            )}

            {/* Final Amount */}
            <div className="border-t pt-4">
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Amount to Pay:</span>
                <span className="text-lg font-bold flex items-center">
                  <CreditCardIcon className="h-5 w-5 mr-1" />
                  {finalAmount > 0 ? (
                    `₹${finalAmount}`
                  ) : (
                    <span className="text-green-600">Free (Wallet)</span>
                  )}
                </span>
              </div>
              {useWallet && walletAmountUsed > 0 && (
                <p className="text-xs text-gray-500 mt-1">
                  Wallet: ₹{walletAmountUsed} | Payment Method: ₹{finalAmount}
                </p>
              )}
            </div>
          </div>

          <div className="flex space-x-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Cancel
            </button>
            <button
              onClick={handleEnroll}
              disabled={enrollmentLoading || (courseFees > 0 && finalAmount === 0 && !useWallet)}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {enrollmentLoading ? 'Processing...' : 'Confirm Enrollment'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentModal;
